<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.attrCode" clearable placeholder="属性编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.attrName" clearable placeholder="属性名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="attrCode" label="属性编码" width="140" />
      <el-table-column prop="attrName" label="属性名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="值类型" width="90" align="center">
        <template slot-scope="{ row }">{{ row.valueType === '02' ? '数值' : '文本' }}</template>
      </el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.attributeId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.attributeId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.attributeId ? '修改产品属性' : '新增产品属性'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="属性编码" required>
          <el-input v-model="form.attrCode" placeholder="如 SIZE / COLOR" />
        </el-form-item>
        <el-form-item label="属性名称" required>
          <el-input v-model="form.attrName" />
        </el-form-item>
        <el-form-item label="值类型">
          <el-radio-group v-model="form.valueType">
            <el-radio label="01">文本</el-radio>
            <el-radio label="02">数值</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
        <el-form-item label="可选值">
          <el-button type="primary" size="mini" @click="form.valueList.push({ attrValue: '' })">添加</el-button>
          <el-table :data="form.valueList" border size="small" style="margin-top:8px">
            <el-table-column label="属性值" min-width="200">
              <template slot-scope="{ row }">
                <el-input v-model="row.attrValue" size="mini" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="{ $index }">
                <el-button type="text" size="mini" @click="form.valueList.splice($index, 1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listAttribute, getAttribute, saveAttribute, updateAttribute, deleteAttribute } from '../../api/attribute'

function emptyForm() {
  return {
    attributeId: '',
    attrCode: '',
    attrName: '',
    valueType: '01',
    forProduct: '1',
    active: '1',
    valueList: []
  }
}

export default {
  name: 'MesAttributePage',
  components: { ListPagination },
  data() {
    return {
      query: { attrCode: '', attrName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      visible: false,
      saving: false,
      form: emptyForm()
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listAttribute({
        currentPage: this.page,
        pageSize: this.pageSize,
        attrCode: this.query.attrCode,
        attrName: this.query.attrName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      if (!id) return
      getAttribute(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row)
        if (!this.form.valueList) this.form.valueList = []
      })
    },
    submit() {
      if (!this.form.attrCode || !this.form.attrName) {
        this.$message.warning('请填写编码和名称')
        return
      }
      this.saving = true
      const payload = Object.assign({}, this.form)
      payload.valueList = (payload.valueList || []).map(v => ({ attrValue: v.attrValue }))
      const req = payload.attributeId ? updateAttribute(payload) : saveAttribute(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确认删除该属性？', '提示', { type: 'warning' }).then(() => {
        deleteAttribute([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
